export default {
  URL_TEST_EXECUTION: '/testExecutions',
  URL_TEST_EXECUTION_BULK: '/testExecutions/bulk',
  URL_TEST_EXECUTION_STATUS: '/testExecutions/status/bulk',
  URL_TEST_EXECUTION_ASSIGNEE: '/testExecutions/assignee/bulk',
  URL_TEST_EXECUTION_INSIGHTS: '/testExecutionInsights',
  URL_LATEST_TEST_EXECUTIONS: '/testExecutions/latest',
  URL_TEST_EXECUTION_STEPS_BULK: '/testExecutionSteps/bulk',
  URL_PROJECT_ISSUE_TYPES: '/projectIssueTypes',
  URL_TEST_STEP: '/testSteps',
  URL_TEST_CASES: '/testCases',
  URL_BULK_TEST_STEP: '/testSteps/bulk',
  URL_TEST_CYCLES: '/testCycles',
  URL_TEST_CASES_IN_CYCLE_POSITION: '/testCasesInCyclePosition',
  URL_TEST_CYCLES_FOR_EXECUTION: '/testCyclesForExecution',
  URL_SEARCH_ADMINISTERED_PROJECTS:
    '/rest/api/2/project/search?expand=issueTypes&action=edit&orderBy=name',
  URL_TEST_EXECUTION_REPORT: '/reports/testExecution/table',
  URL_TEST_EXECUTION_REPORT_CHARTS: '/reports/testExecution/charts',
  URL_IMPORT_TEST_CASES: '/testCases/import',
  URL_TEST_EXECUTION_STEP_LINKED_ISSUE: '/testExecutionSteps',
  URL_QALITY_ISSUE_LINK_TYPE: '/qalityIssueLinkType',
  URL_TRACEABILITY_REPORT: '/reports/traceability/table',
  URL_QALITY_TEST_ISSUE_TYPE: '/qalityTestIssueType',
  URL_FOLDERS: '/folders',
  URL_EXECUTION_STATUSES: '/statuses',
  URL_TEST_TYPES: '/testTypes',
  URL_APPLICATION_INFO: '/application/info',
};
